import { Spin, Upload } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import LightboxGroup from '../../../../components/LightboxGroup/LightboxGroup';
import generateUrlFromBlob from '../../../../helpers/generateUrlFromBlob';
import validateFile from '../../../../helpers/validateFile';
import { BigPictureIcon } from '../../../../resource/icons';
import createDescriptionAttachments from '../../requests/createRoomImages';
import styles from './DescriptionPictures.module.scss';

const DescriptionPictures = ({ attachments, descriptionId, onUpdate }) => {
  const userCanEdit = useSelector(
    (store) => store.authentication.userInfo.CanCreateOffice
  );
  const queryClient = useQueryClient();
  const [showPreview, setShowPreview] = useState(false);
  const [loading, setLoading] = useState(false);
  const [attachedPhotos, setAttachedPhotos] = useState([]);
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);

  const createPhotos = useCallback(() => {
    const photos = attachments.map((attachment) => ({
      id: attachment.id,
      src: generateUrlFromBlob(attachment.file),
    }));

    setAttachedPhotos(photos);
  }, [attachments]);

  const handleClosePreview = useCallback(() => {
    setShowPreview(false);
    setCurrentPhotoIndex(0);
  }, []);

  const handlePhotoClick = (index) => {
    setShowPreview(true);
    setCurrentPhotoIndex(index);
  };

  const beforeUpload = useCallback(
    (image) => {
      setLoading(true);
      const validated = validateFile(image, { onlyPicture: true });
      if (!validated) {
        return false;
      }
      (async () => {
        await createDescriptionAttachments(descriptionId, [image]);
        onUpdate(descriptionId, [image]);
        setLoading(false);
      })();
      return false;
    },
    [descriptionId, onUpdate]
  );

  useEffect(() => {
    if (attachments) {
      createPhotos();
    }
  }, [attachments, createPhotos]);

  if (userCanEdit && (!attachments || !attachments?.length)) {
    return (
      <Upload.Dragger
        beforeUpload={beforeUpload}
        multiple
        showUploadList={false}
      >
        <Spin size="large" spinning={loading}>
          <div className={styles.uploader}>
            <BigPictureIcon />

            <span className={styles.text}>
              Нажмите или перетащите файл, чтобы загрузить изображение
            </span>
          </div>
        </Spin>
      </Upload.Dragger>
    );
  } else {
    return (
      <>
        <ul className={styles.gallery}>
          {attachedPhotos.map((photo, index) => {
            return (
              <li key={photo.id} className={styles.galleryItem}>
                <img
                  className={styles.galleryPhoto}
                  src={photo.src}
                  alt="изображение объекта"
                  onClick={() => handlePhotoClick(index)}
                />
              </li>
            );
          })}
        </ul>
        {attachments && showPreview && (
          <LightboxGroup
            visible={showPreview}
            onClose={handleClosePreview}
            attachments={attachments}
            attachment={attachments[currentPhotoIndex]}
            url={`/RentPlace/description/${descriptionId}/attachment`}
            params={{ fileName: '' }}
            imageParamField="fileName"
          />
        )}
      </>
    );
  }
};

export default DescriptionPictures;
